/**
 * Validates if a phone number is a valid US phone number in allowed formats
 * @param phoneNumber - The phone number string or number to validate
 * @returns boolean - True if valid US phone number, false otherwise
 */
export const isValidUSPhone = (phoneNumber: string | number): boolean => {
  // Convert to string if it's a number
  const phoneString = String(phoneNumber);
  
  // Remove all non-digit characters
  const digitsOnly = phoneString.replace(/\D/g, '');
  
  // Must be exactly 10 or 11 digits
  if (digitsOnly.length !== 10 && digitsOnly.length !== 11) {
    return false;
  }
  
  // If 11 digits, must start with 1 (country code)
  if (digitsOnly.length === 11 && !digitsOnly.startsWith('1')) {
    return false;
  }
  
  // Get the area code (first 3 digits after country code)
  const areaCodeStartIndex = digitsOnly.length === 11 ? 1 : 0;
  const areaCode = digitsOnly.substring(areaCodeStartIndex, areaCodeStartIndex + 3);
  
  // Area code must start with 2-9 (NANP standard)
  return /^[2-9]/.test(areaCode);
};

/**
 * Audience CSVs for WhatsApp/SMS (and international call lists) store E.164
 * without "+". Example: 84972746237 is a valid Vietnam mobile.
 */
export const isValidAudiencePhone = (phoneNumber: string | number): boolean => {
  if (isValidUSPhone(phoneNumber)) return true;
  const digitsOnly = String(phoneNumber).replace(/\D/g, "");
  if (digitsOnly.length < 11 || digitsOnly.length > 15) return false;
  if (digitsOnly.startsWith("0")) return false;
  return /^[1-9]\d{10,14}$/.test(digitsOnly);
}; 